import { type Middleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { loggerMiddleware } from '../utils/redux/loggerMiddleware';

export const middlewares: Middleware[] = [thunkMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(loggerMiddleware);
}
